import { CuriosityNamespace, CuriosityTranslation } from '@procureai/curiosity-ui-mui';
import type { JSX } from 'react';

export type CuriosityTranslationValue = CuriosityTranslation<Record<string, any>>;
export interface TransCuriosityLookupProps {
  // required field provided by parent <Trans> component
  context: any;
  // optional fields provided by parent <Trans> component for customized value handling
  valueGetter?: (curiosityTranslation: CuriosityTranslationValue) => string | JSX.Element;
  // optional fields provided through translation template's component replacement
  ns?: CuriosityNamespace;
  field?: string;
  delimiter?: string;
  zero?: string;
}

export interface CuriosityLookupProps {
  ids: string | string[];
  ns: CuriosityNamespace;
  delimiter: string;
  valueGetter?: (curiosityTranslation: CuriosityTranslationValue) => string | JSX.Element;
}

export interface LookupErrorMessageProps {
  variant: ErrorVariant;
}

export enum ErrorVariant {
  FIELD = 'field',
  NS = 'namespace',
}
